<template>
  <div><a v-bind:href="href">{{$mq == 'sm' ? 'DL' : 'Download'}} Data</a></div>
</template>

<script>
import config from '../../config'

export default {
  name: 'ReportDownload',

  computed : {
    default_href : function(){
      return config.DATA_URI + "/report/" +
             this.$store.state.report.period +
             "?metrics=" + config.DEFAULT_REPORT_METRICS.join(",");
    },

    selected_href : function(){
      var ts = this.selected_report.timestamp;
      if(this.selected_report.period == 'month'){
        ts = this.selected_report.timestamp.split("-")
        ts = ts[2] + "-" + ts[0] + "-01"
      }

      return config.DATA_URI + "/report/" +
             this.selected_report.period + "/" + ts +
             "?metrics=" + config.TIMESTAMP_REPORT_METRICS.join(",");
    },

    href : function(){
      return this.have_selected ? this.selected_href :
                                   this.default_href ;
    },

    selected_report : function(){
      return this.$store.state.report.selected;
    },

    have_selected : function(){
      return !!this.selected_report.period;
    }
  }
}
</script>

<style scoped>
div{
  position: absolute;
  bottom: 3px;
  font-size: 0.8em;
}
</style>
